@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}

<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_topic_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>{{ title }}</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.TOPICNAME),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOPICNAME),
            }"
          >
            <mat-label>Topic Name</mat-label>
            <input [(ngModel)]="TopicDialoge.TOPICNAME" name="TOPICNAME" matInput />
            <!-- <mat-icon matSuffix class="secondary-text">account_circle</mat-icon> -->
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.COMMENT),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMMENT),
            }"
            appearance="outline"
            fxFlex="50"
            class="pr-1"
          >
            <mat-select
              [(ngModel)]="TopicDialoge.selective"
              name="selective"
              (selectionChange)="TopicClassChange($event.value)"
            >
              <mat-option value="1">is a head topic</mat-option>
              <mat-option value="2">is sub topic of</mat-option>
            </mat-select>
          </mat-form-field>

          @if (ShowParent == 'yes') {
            <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
              <mat-label>Parent</mat-label>
              <mat-select
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.COMMENT),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMMENT),
                }"
                [(ngModel)]="TopicDialoge.Parent"
                name="Parent"
                (selectionChange)="TopicNameChange($event.value)"
              >
                @for (val of MainTopicClass; track val) {
                  <mat-option [value]="val.TOPICNAME">
                    {{ val.TOPICNAME }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (action != 'edit') {
      <button
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveTopic()"
        cdkFocusInitial
        class="h-[36px]"
      >
        @if (isspiner) {
          <mat-spinner
            style="
              zoom: 0.2;
              position: absolute;
              right: 0;
              left: 0;
              margin: auto;
              top: 0;
              bottom: 0;
            "
          ></mat-spinner>
        }
        Save
      </button>
    }
    @if (action == 'edit') {
      <button
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveTopic()"
        cdkFocusInitial
        class="h-[36px]"
      >
        @if (isspiner) {
          <mat-spinner
            style="
              zoom: 0.2;
              position: absolute;
              right: 0;
              left: 0;
              margin: auto;
              top: 0;
              bottom: 0;
            "
          ></mat-spinner>
        }
        Update
      </button>
    }
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial class="h-[36px]">
      Don't Save
    </button>
  </mat-dialog-actions>
</div>
